<template>
  <el-select
    ref="selectTree"
    v-model="departmentId"
    placeholder="选择部门"
    v-if="type == 'select'"
    filterable
  >
    <el-option
      :key="departmentId"
      :label="departmentName"
      :value="departmentId"
      hidden
    >
    </el-option>
    <el-tree
      ref="tree"
      :data="departmentList"
      :props="defaultProps"
      node-key="defaultProps.value"
      @node-click="handleNodeClick"
    ></el-tree>
  </el-select>

  <el-input v-else v-model="departmentName"></el-input>
</template>
<script>
import { post } from "../utils/request";

export default {
  name: "DepartmentSelect",
  data() {
    return {
      departmentList: [],
      departmentId: "",
      departmentName: "",
      defaultProps: {
        children: "children",
        label: "departmentName",
        value: "departmentId",
      },
      type: "select",
    };
  },
  watch: {
    departmentId(newVal, oldVal) {
      this.$emit("departmentId", this.departmentId);
    },
  },
  created() {
    this.depSearch();
  },
  methods: {
    handleNodeClick(data) {
      this.departmentId = data.departmentId;
      this.departmentName = data.departmentName;
      this.$refs.selectTree.blur();
    },
    acceptId(departmentId) {
      this.departmentId = departmentId;
      this.departmentName = this.getNamefromList(
        departmentId,
        this.departmentList
      );
    },
    initComp(departmentId, departmentName) {
      this.departmentId = departmentId;
      this.departmentName = departmentName;
    },
    // 从departmentList中根据departmentId返回departmentName
    getNamefromList2(departmentId, departmentList) {
      for (let i = 0, len = departmentList.length; i < len; i++) {
        if (departmentList.length <= 0) {
          return;
        }
        if (departmentList[i].departmentId == departmentId) {
          return departmentList[i].departmentName;
        }
        return this.getNamefromList(departmentId, departmentList[i].children);
      }
    },
    getNamefromList(departmentId, departmentList) {
      if (departmentList == null || departmentList.length == 0) {
        return;
      }
      for (let i = 0, len = departmentList.length; i < len; i++) {
        if (departmentList[i].departmentId == departmentId) {
          return departmentList[i].departmentName;
        }
      }
      for (let i = 0, len = departmentList.length; i < len; i++) {
        return this.getNamefromList(departmentId, departmentList[i].children);
      }
    },

    /**
     * @description 查询所有部门科室
     * @function POST /department/search/tree
     *
     * @param departmentId
     */
    depSearch() {
      // let regionIdList = [];
      // regionIdList.push(
      //   JSON.parse(sessionStorage.getItem("regionInfo")).regionId
      // );
      // post("/department/search/tree", JSON.stringify(regionIdList)).then(
      //   (res) => {
      //     if (res.code == 200) {
      //       this.departmentList = JSON.parse(res.data.departmentList);
      //       let obj = {
      //         departmentId: 0,
      //         departmentName: "无",
      //       };
      //       this.departmentList.push(obj);
      //     }
      //   }
      // );
      let bureauId = JSON.parse(
        sessionStorage.getItem("departmentInfo")
      ).departmentId;
      let deptManageInfo = sessionStorage.getItem("deptManageInfo");
      if (deptManageInfo != null && deptManageInfo != "") {
        this.departmentList = this.findBureau(
          bureauId,
          JSON.parse(deptManageInfo)
        );
        return;
      }
      let regionIdList = [];
      regionIdList.push(
        JSON.parse(sessionStorage.getItem("regionInfo")).regionId
      );
      post("/department/search/tree", JSON.stringify(regionIdList)).then(
        (res) => {
          if (res.code == 200) {
            res = JSON.parse(res.data.departmentList);
            this.departmentList = this.findBureau(bureauId, res);
            sessionStorage.setItem("deptManageInfo", JSON.stringify(res));
          }
        }
      );
    },
    // 从bureauList中找到bureauId的单位，树形结构
    findBureau(bureauId, bureauList) {
      for (let i = 0; i < bureauList.length; i++) {
        if (bureauList[i].departmentId === bureauId) {
          let res = [];
          res.push(bureauList[i]);
          return res;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
</style>